/* eslint-disable max-len */
import React from 'react';
import { motion } from 'framer-motion'; // Import motion from framer-motion
import './index.css';
import redbull from '../../assets/images/bullet.svg';
import HeaderSocial from '../HeaderSocial';

const Header = () => (
  <motion.header id="home" className="container header_container">
    <motion.h5 initial={{ opacity: 0, y: -50 }} animate={{ opacity: 1, y: 0 }} transition={{ type: 'spring', duration: 1.25, delay: 0.5 }}>
      Hey there. I am
    </motion.h5>
    <div className="header-text">
      <motion.h1 initial={{ opacity: 0, y: -50 }} animate={{ opacity: 1, y: 0 }} transition={{ type: 'spring', duration: 1.25, delay: 1 }}>
        Jalloh
        <br />
        Abdoul
      </motion.h1>
      <motion.img className="img-bull" src={redbull} alt="Bull red" initial={{ opacity: 0, scale: 0 }} animate={{ opacity: 1, scale: 1 }} transition={{ type: 'tween', duration: 1 }} />
    </div>
    <motion.p initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0 }} transition={{ type: 'tween', duration: 1, delay: 0.5 }}>
      <span className="redSpan">A Full-Stack web developer</span>
      <br />
      {' '}
      With a background in developing efficient software applications in a global market. More than 1300+ hours of experience, including mentoring 10+ junior developers to achieve concrete goals on a strict deadline. Strong skills include React, Redux, JavaScript, Ruby on Rails, Figma, and Animation Libraries!
    </motion.p>
    <motion.div initial={{ opacity: 0, x: 100 }} animate={{ opacity: 1, x: 0 }} transition={{ type: 'tween', duration: 1, delay: 1 }}>
      <p className="work">
        see my work
        <HeaderSocial />
      </p>
    </motion.div>
    <a className="scroll_down" href="#about">
      Scroll Down
    </a>
  </motion.header>
);

export default Header;
